import React from 'react';

const FunnelIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" /></svg>
);
const ShieldIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
);
const TrendIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M23 6l-9.5 9.5-5-5L1 18" /><path d="M17 6h6v6" /></svg>
);

// `ghost` is the oversized pale numeral behind each card's top-right corner.
const CARDS = [
    { tone: 'blue', Icon: FunnelIcon, ghost: '£0', title: 'Free qualified deal flow', body: 'Come onto our platform for free, and receive qualified, pre-diligenced dealflow from the companies, VCs and advisors already on our platform.' },
    { tone: 'pink', Icon: ShieldIcon, ghost: '60%', title: 'AI diligence at a fraction of the cost', body: 'Enable your companies to be quickly pre-diligenced in days, prior to going to the expense of full diligence.' },
    { tone: 'green', Icon: TrendIcon, ghost: 'Gold', title: 'Speed your portfolio exits', body: 'Keep your portfolio companies always "exit ready" — for trade sale, secondary, or PISCES.' },
];

const PEWhySection = () => (
    <section className="lp-pe-why" style={{ marginBottom: 0 }}>
        <div className="lp-pe-wrap">
            <div className="lp-pe-why-head">
                <span className="lp-pe-eyebrow" data-lp-reveal><span className="dot" />Why Diligentsia</span>
                <h2 className="lp-pe-h2 is-lg" data-lp-reveal data-lp-delay="60">Exit quicker, at higher valuations.</h2>
            </div>
            <div className="lp-pe-why-grid">
                {CARDS.map((c, i) => (
                    <div className="lp-pe-why-card" key={c.title} data-lp-reveal data-lp-delay={i * 80}>
                        <div className="lp-pe-why-ghost" aria-hidden="true">{c.ghost}</div>
                        <div className={`lp-pe-why-icon is-${c.tone}`}><c.Icon /></div>
                        <h3>{c.title}</h3>
                        <p>{c.body}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default PEWhySection;
